import React, { useState } from 'react'
import './home.css'
import Navigation from '../../Component/Navigation/Navigation'
import banner1 from '../../resources/images/banner-1.jpg'
import banner2 from '../../resources/images/banner-2.jpg'
import banner3 from '../../resources/images/banner-3.jpg'
import loanImg from '../../resources/images/calculator-1.jpg'
import { FaShieldAlt, FaRegClock, FaChartLine, FaClock, FaBell } from 'react-icons/fa'
import OnlineService from '../../Component/Online Service/OnlineService'
import Footer from '../../Component/Footer/Footer'
import { Link } from 'react-router-dom'
import { toast } from 'wc-toast'
import noti from '../../resources/images/typings.jpg'
import bank from '../../resources/images/forex.webp'
import checkings from '../../resources/images/checking.png'
import savings from '../../resources/images/savings.png'
import business from '../../resources/images/business.png'
import illustration from '../../resources/images/Revenue-bro.svg'
import getStarted from '../../resources/images/get-started.svg'
import questionMark from '../../resources/images/Question-mark.jpg'
import { useAuthContext } from '../../Hooks/useAuthContext'

function Home() {
  const [heroView, setHeroView] = useState(banner1)
  const [NLEmail, setNLEmail]   = useState(null)
  const { user }                = useAuthContext()

  const handleNLSubmit = (e) => {
    e.preventDefault()
    if (!NLEmail) toast.error('Enter an Email')
    else toast.success('News Letter Signup Successful')
  }

  /* ── Loan calculator ──────────────────────────────────────── */
  const [loanAmount, setLoanAmount]       = useState('')
  const [loanTerm, setLoanTerm]           = useState('')
  const [interestRate, setInterestRate]   = useState('')
  const [monthlyPayment, setMonthlyPayment] = useState('')

  const handleInputChange = (e) => {
    const { name, value } = e.target
    console.log(value)
    if (name === 'loanAmount')    setLoanAmount(value)
    else if (name === 'loanTerm') setLoanTerm(value)
    else if (name === 'interestRate') setInterestRate(value)
  }

  const calculateMonthlyPayment = () => {
    const amount = parseFloat(loanAmount)
    const term   = parseInt(loanTerm)
    const rate   = parseFloat(interestRate) / 100 / 12
    const mp     = (amount * rate) / (1 - Math.pow(1 + rate, -term))
    console.log(mp, amount, rate)
    setMonthlyPayment(mp.toFixed(2))
  }

  const handleSubmit = (e) => { e.preventDefault(); calculateMonthlyPayment() }

  const handleReset = () => {
    setLoanAmount(''); setLoanTerm(''); setInterestRate(''); setMonthlyPayment('')
  }

  /* ── Static data ──────────────────────────────────────────── */
  const accountArray = [
    {
      icon: checkings,
      title: 'Checking Account',
      text: 'Choose from our checking options that allow you to earn interest, avoid fees, and easily manage your account.',
      btn: 'Open Account',
    },
    {
      icon: savings,
      title: 'Savings Accounts',
      text: 'Save for your goals and watch your money grow with a CD, a money market account, a savings account. Your future starts now.',
      btn: 'Start Saving',
    },
    {
      icon: business,
      title: 'Business Account',
      text: 'Take charge of your business banking with a business bank account. Services including virtual cards, team management and more.',
      btn: 'Open Account',
    },
  ]

  const blockArray = [
    {
      icon: <FaShieldAlt />,
      title: 'Secure International Transactions',
      text: 'Encryption, authentication, and compliance ensure secure international transactions for global financial stability.',
    },
    {
      icon: <FaRegClock />,
      title: '24/7 Support from the Expert Team',
      text: 'Our expert team provides 24/7 support for seamless assistance and guidance in all transactions.',
    },
    {
      icon: <FaChartLine />,
      title: 'Lowest Processing Fees Than Other Banks',
      text: 'Our bank offers the lowest processing fees compared to other banks, ensuring cost-effective transactions.',
    },
    {
      icon: <FaClock />,
      title: 'Fast Refunds',
      text: 'Experience fast refunds with our efficient processing to ensure quick and hassle-free reimbursements.',
    },
  ]

  return (
    <div className="home-page">

      {/* ── Navigation ──────────────────────────────────────── */}
      <div className="navbar">
        <Navigation />
      </div>

      {/* ══════════════════════════════════════════════════════
          HERO
      ══════════════════════════════════════════════════════ */}
      <div
        className="hp-hero"
        style={{ backgroundImage: `url(${heroView})` }}
      >
        <div className="hp-hero__content">
          <div className="hp-hero__inner">
            <span className="hp-hero__eyebrow">JFE Bank — Trusted Since Day One</span>
            <h1 className="hp-hero__title">
              Open Our <em>Current</em><br />Account Online
            </h1>
            <p className="hp-hero__sub">
              Unlock Your Financial Potential with Us – Your Trusted Banking Partner
            </p>
            <div className="hp-hero__actions">
              <Link to="/contact" style={{ textDecoration: 'none' }}>
                <button className="hp-btn hp-btn--white">Make an Appointment</button>
              </Link>
              <Link to="/register" style={{ textDecoration: 'none' }}>
                <button className="hp-btn hp-btn--outline" style={{ borderColor: 'rgba(255,255,255,.35)', color: '#fff' }}>
                  Open an Account →
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          FEATURE BLOCKS
      ══════════════════════════════════════════════════════ */}
      <div className="hp-blocks">
        <div className="hp-blocks__grid">
          {blockArray.map((block, i) => (
            <div className="hp-block" key={i}>
              <div className="hp-block__icon">{block.icon}</div>
              <h4>{block.title}</h4>
              <p>{block.text}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          SPLIT — Real-time Notifications
      ══════════════════════════════════════════════════════ */}
      <div className="hp-split">
        <div className="hp-split__inner">
          <div className="hp-split__text">
            <span className="hp-split__badge">
              <FaBell /> Smart Banking
            </span>
            <h2 className="hp-heading">
              Real-time <em>Notifications</em>
            </h2>
            <p className="hp-body">
              Your customer stays informed in real time with everything that's happening
              on their account: payments, transfer, advice. Get visibility on your
              customers' flows to anticipate their needs.
            </p>
            <ul className="hp-split__checks">
              <li>Cards that work all across the world.</li>
              <li>No ATM fees. No minimum balance. No overdrafts.</li>
            </ul>
          </div>
          <div className="hp-split__image">
            <img src={noti} alt="Real-time banking notifications" />
          </div>
        </div>
      </div>

      <hr className="hp-rule" />

      {/* ══════════════════════════════════════════════════════
          SPLIT — Better Way to Save & Invest
      ══════════════════════════════════════════════════════ */}
      <div className="hp-split">
        <div className="hp-split__inner hp-split__inner--reverse">
          <div className="hp-split__text">
            <span className="hp-split__badge">
              <FaShieldAlt /> Safe Investments
            </span>
            <h2 className="hp-heading">
              The Better Way to <em>Save &amp; Invest</em>
            </h2>
            <p className="hp-body">
              {process.env.REACT_APP_APP_NAME} helps over 2 million customers achieve their financial goals
              by helping them save and invest with ease. Put that extra cash to use without
              putting it at risk with {process.env.REACT_APP_APP_NAME}.
            </p>
            <ul className="hp-split__checks">
              <li>Profitable to invest and handy to manage.</li>
              <li>Highest returns on your investments.</li>
            </ul>
          </div>
          <div className="hp-split__image">
            <img src={bank} alt="Safe investments and savings" />
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          ACCOUNTS
      ══════════════════════════════════════════════════════ */}
      <div className="hp-accounts">
        <div className="hp-accounts__head">
          <span className="hp-eyebrow">Open your account from anywhere in the world</span>
          <h2 className="hp-heading">Solutions for Every Business Need.</h2>
          <p className="hp-body">
            Power up your business with a full-stack online bank account that fits your needs.
          </p>
        </div>
        <div className="hp-accounts__grid">
          {accountArray.map((account, i) => (
            <div className="hp-account-card" key={i}>
              <div className="hp-account-card__icon">
                <img src={account.icon} alt={account.title} />
              </div>
              <h4>{account.title}</h4>
              <p>{account.text}</p>
              <Link to="/register" className="hp-account-card__link">
                {account.btn} →
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          ONLINE SERVICES
      ══════════════════════════════════════════════════════ */}
      <div className="hp-services">
        <div className="hp-services__head">
          <span className="hp-eyebrow">Our Services</span>
          <h2 className="hp-heading">
            Online Banking at Your <em>Fingertips</em>
          </h2>
        </div>
        <OnlineService />
      </div>

      {/* ══════════════════════════════════════════════════════
          QUESTIONS
      ══════════════════════════════════════════════════════ */}
      <div className="hp-questions">
        <div className="hp-questions__inner">
          <div className="hp-questions__head">
            <span className="hp-eyebrow">Your news and information</span>
          </div>
          <div className="hp-questions__card">
            <div className="hp-questions__image">
              <img src={questionMark} alt="Ask us anything" />
            </div>
            <div className="hp-questions__text">
              <h4>Account questions? Just ask me.</h4>
              <p className="hp-body">
                I'm just a few taps away — open your {process.env.REACT_APP_APP_NAME} app and say hello.
              </p>
              <div>
                <Link to="/tickets/create_ticket" style={{ textDecoration: 'none' }}>
                  <button className="hp-btn hp-btn--navy">Ask Questions</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          APPLY FOR A LOAN  — dark CTA band
      ══════════════════════════════════════════════════════ */}
      <div className="hp-loan-cta">
        <div className="hp-loan-cta__inner">
          <div className="hp-loan-cta__text">
            <h3>Need a Personalised Solution?</h3>
            <p>
              Get in touch with us, and we will help you to create the right one
              for your business or personal needs.
            </p>
          </div>
          <Link to="/login" style={{ textDecoration: 'none' }}>
            <button className="hp-btn hp-btn--white">Apply for a Loan</button>
          </Link>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          LOAN CALCULATOR
      ══════════════════════════════════════════════════════ */}
      <div className="hp-calculator">
        <div className="hp-calculator__inner">
          <div>
            <div className="hp-calculator__form-head">
              <span className="hp-eyebrow">Calculate Loan</span>
              <h2 className="hp-heading">Online EMI Calculator</h2>
            </div>
            <div className="hp-calculator__fields">
              <div className="hp-calc-field">
                <label>Loan Amount</label>
                <input
                  type="number"
                  name="loanAmount"
                  placeholder="Enter loan amount"
                  value={loanAmount}
                  onChange={handleInputChange}
                />
              </div>
              <div className="hp-calc-field">
                <label>Number of Months</label>
                <input
                  type="number"
                  name="loanTerm"
                  placeholder="Loan term in months"
                  value={loanTerm}
                  onChange={handleInputChange}
                />
              </div>
              <div className="hp-calc-field">
                <label>Interest Rate (%)</label>
                <input
                  type="number"
                  name="interestRate"
                  placeholder="Annual interest rate"
                  value={interestRate}
                  onChange={handleInputChange}
                />
              </div>
              <div className="hp-calc-field">
                <label>Monthly Payment</label>
                <input
                  type="number"
                  readOnly
                  value={monthlyPayment}
                  placeholder="Result will appear here"
                />
              </div>
            </div>
            <div className="hp-calculator__actions">
              <button className="hp-btn hp-btn--navy" onClick={handleSubmit}>
                Calculate
              </button>
              <button className="hp-btn hp-btn--outline" onClick={handleReset}>
                Reset Data
              </button>
            </div>
          </div>
          <div className="hp-calculator__image">
            <img src={loanImg} alt="Loan calculator" />
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          GET STARTED
      ══════════════════════════════════════════════════════ */}
      <div className="hp-get-started">
        <div className="hp-get-started__card">
          <div className="hp-get-started__text">
            <h3>Ready to get started?</h3>
            <p>
              It only takes a few minutes to register your FREE {process.env.REACT_APP_APP_NAME} account.
            </p>
            <Link to="/register" style={{ textDecoration: 'none' }}>
              <button className="hp-btn hp-btn--white">Open an Account</button>
            </Link>
          </div>
          <div className="hp-get-started__image">
            <img src={getStarted} alt="Get started with JFE Bank" />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Home